import { Metadata } from "next";
import Steps from "@/Component/Auth/Register/BrandSteps";

export const metadata: Metadata = {
    title: "Registration Steps | Connector Club",
    description: "",
};

const StepsPage = () => {
  return (
    <Steps />
  )
}

export default StepsPage
